/**
 * One-time migration of a localStorage entry to a new key (Godilog → Serva
 * rename): copies the old value to the new key unless one is already set, then
 * removes the old key. Safe to call on every read; a no-op once migrated.
 */
export function migrateStorageKey(oldKey: string, newKey: string): void {
    try {
        const oldValue = localStorage.getItem(oldKey);
        if (oldValue === null) return;
        if (localStorage.getItem(newKey) === null) {
            localStorage.setItem(newKey, oldValue);
        }
        localStorage.removeItem(oldKey);
    } catch {
        // localStorage may be unavailable (e.g. private browsing restrictions)
    }
}
